module.exports = __webpack_public_path__ + "media/images/athletes/3569-73d9e1f574be0779c82d3c09871c1455.png";